import styled from 'styled-components';
import { Typography } from 'components/elements';

export const Title = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 0;
`;

export const TitleWordStrong = styled.strong<{ type: string }>`
  color: ${({ type }) => (type === 'aprovar' ? 'green' : '#b30303')};
  font-weight: 600;
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin: 10px 0;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const Label = styled(Typography)`
  width: 100%;
  max-width: 150px;
  color: ${({ theme }) => theme.palette.black.main};
`;

export const Value = styled(Typography)`
  width: 100%;
  color: ${({ theme }) => theme.palette.black.main};
`;
